export default __webpack_public_path__ + "static/media/Bjorn_SW.f5510fcf.png";